import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { convertToGMTPlus3, DataIso } from '@/shared/utils/datas';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import {
  CreateEventoInstitucionalDto,
  DeleteEventoInstitucional,
  GetEventoInstitucional,
  SetEventoInstitucional,
} from '@/modules/business/evento-institucional/evento-institucional.service';
import { Tabelas } from '@/shared/constants/tables';
import { toast } from 'react-toastify';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function EventoInstitucionalEditPage() {
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  const [loaded, setLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [formData, setFormData] = useState<CreateEventoInstitucionalDto>({
    titulo: '',
    descricao: '',
    data_inicial: '',
    data_final: '',
  });
  const [editadoPor, setEditadoPor] = useState<{ id?: number; username?: string; nome?: string }>();
  const [editadoEm, setEditadoEm] = useState<string | undefined>();

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.EventoInstitucional_Criar, onClick: () => {} },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  useEffect(() => {
    if (id > 0) {
      GetEventoInstitucional(id)
        .then((result) => {
          if (!result) return;
          setFormData({
            id: result.id,
            titulo: result.titulo,
            descricao: result.descricao || '',
            data_inicial: DataIso(result.data_inicial) || '',
            data_final: DataIso(result.data_final) || '',
          });
          setEditadoPor(result.editadoPor);
          setEditadoEm(result.editadoEm);
          setLoaded(true);
        })
        .catch((res) => toast.error(String(res)));
    } else {
      setLoaded(true);
    }
  }, [id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.titulo.trim()) {
      toast.error('Informe o título do evento.');
      return;
    }
    if (!formData.data_inicial || !formData.data_final) {
      toast.error('Informe as datas inicial e final.');
      return;
    }

    setIsLoading(true);
    const payload: CreateEventoInstitucionalDto = {
      id: id > 0 ? id : undefined,
      titulo: formData.titulo.trim(),
      descricao: formData.descricao?.trim() || null,
      data_inicial: convertToGMTPlus3(formData.data_inicial).toISOString(),
      data_final: convertToGMTPlus3(formData.data_final).toISOString(),
    };

    SetEventoInstitucional(payload)
      .then((res) => {
        toast.success(String(res));
        navigate(Links.EventoInstitucional_Index);
      })
      .catch((res) => toast.error(String(res)))
      .finally(() => setIsLoading(false));
  };

  const handleExcluir = () => {
    setModalExcluirShow(false);
    DeleteEventoInstitucional(id)
      .then((res) => {
        toast.success(String(res));
        navigate(Links.EventoInstitucional_Index);
      })
      .catch((res) => toast.error(String(res)));
  };

  if (!loaded) return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>{id > 0 ? 'Editar evento institucional' : 'Novo evento institucional'}</h3>
          <hr className="pb-3" />
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="titulo" className="form-label">
              Título
            </label>
            <input
              id="titulo"
              name="titulo"
              className="form-control"
              value={formData.titulo}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-3 mb-3">
            <label htmlFor="data_inicial" className="form-label">
              Data inicial
            </label>
            <input
              id="data_inicial"
              name="data_inicial"
              type="date"
              className="form-control"
              value={formData.data_inicial}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-3 mb-3">
            <label htmlFor="data_final" className="form-label">
              Data final
            </label>
            <input
              id="data_final"
              name="data_final"
              type="date"
              className="form-control"
              value={formData.data_final}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-12 mb-3">
            <label htmlFor="descricao" className="form-label">
              Descrição
            </label>
            <textarea
              id="descricao"
              name="descricao"
              className="form-control"
              rows={4}
              value={formData.descricao || ''}
              onChange={handleChange}
            />
          </div>

          <EditadoPorRodape
            dados={{
              editadoPor: editadoPor ?? undefined,
              editadoEm: editadoEm,
            }}
          />

          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modalExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
        mensagemPersonalizada="Confirma a exclusão deste evento? Só é permitido se não houver ausências vinculadas."
      />

      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.evento_institucional}
        idRegistro={id}
      />
    </>
  );
}
